// extracted by mini-css-extract-plugin
export default {"centered":"_3SRyn","unsubscribe-width":"_3BeE9","unsubscribeWidth":"_3BeE9"};